import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '@cognitiv/cyprus-ui';
import { normalizeParamsConnection } from 'ducks/batch-definition/utils';
import { selectBatch } from 'ducks/batch-definition-dep/selectors';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import {
  selectCardChildren,
  selectCardChildrens,
  selectCardInfo,
  selectCardParent,
  selectParameterConnectionsView,
} from 'ducks/modals/selectors';
import { setModal } from 'ducks/modals/slices';
import { CardInfoParams } from 'ducks/types/common-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { BatchDefinitionParameter } from 'modals/parameter-connections/BatchDefinitionParameter';
import { CardInfoChildrenParams } from 'modals/parameter-connections/CardInfoChildrenParams';
import { Legend } from 'modals/parameter-connections/component/Legend';
import { useParameterConnectionsActions } from 'modals/parameter-connections/hooks/useParameterConnectionsActions';
import { shallowEqual } from 'react-redux';

import cn from 'modals/parameter-connections/component/Components.module.scss';

export const ParameterConnections = () => {
  const dispatch = useAppDispatch();
  const { theme } = useSwitchTheme();
  const [, setCardChildrens] = useState<(number | CardInfoParams)[]>();

  const batch = useAppSelector(selectBatch, shallowEqual);
  const parameter_connections_view = useAppSelector(selectParameterConnectionsView, shallowEqual);
  const card_info = useAppSelector(selectCardInfo, shallowEqual);
  const card_parents = useAppSelector(selectCardParent, shallowEqual);
  const card_children = useAppSelector(selectCardChildren, shallowEqual);
  const card_childrens = useAppSelector(selectCardChildrens, shallowEqual);

  useEffect(() => {
    setCardChildrens(normalizeParamsConnection(card_parents, card_childrens));
  }, [card_childrens, card_parents]);

  const handleCloseModal = useCallback(() => {
    dispatch(setModal({ parameter_connections: { card_info }, parameter_connections_view: false }));
  }, [card_info, dispatch]);

  const { length, children_params, current_params, isCurrentBatchCardInfo, handleCreateConnection } =
    useParameterConnectionsActions(card_children, card_info, batch);

  return (
    <>
      <Modal
        name="parameter_connections_view"
        show={parameter_connections_view}
        width={564}
        padding={0}
        close_box={50}
        onClose={handleCloseModal}
        standard={false}
      >
        <h2
          className={cn.header}
          style={{
            color: theme.font_color,
            backgroundColor: theme.element_background,
            borderBottom: theme.border,
          }}
        >
          Parameter Connections
        </h2>
        <form className={cn.body} style={{ backgroundColor: theme.element_background }}>
          <div className={cn.parameterConnectionColumns}>
            <BatchDefinitionParameter
              params={current_params}
              length={length}
              handleCreateConnection={handleCreateConnection}
            />
            <CardInfoChildrenParams
              params={children_params}
              isCurrentBatchCardInfo={isCurrentBatchCardInfo}
              handleCreateConnection={handleCreateConnection}
            />
          </div>
          <Legend />
        </form>
      </Modal>
    </>
  );
};
